const VERSION = '3.2.0';
export function getVersionString() {
    return VERSION;
}
